import { useQuery } from '@tanstack/react-query'
import { backofficeApi } from '@/lib/backoffice-api'
import type { BackofficeOverview } from '@/types/backoffice'

export function useBackofficeMetrics() {
  return useQuery({
    queryKey: ['backoffice', 'metrics', 'overview'],
    queryFn: () =>
      backofficeApi.get<BackofficeOverview>('/backoffice/metrics/overview').then((r) => r.data),
  })
}
